import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export function SquabInvite({ playId, className = "mb-6 border border-primary px-5 py-3 text-primary font-mono-caps text-xs disabled:opacity-50" }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const invite = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/squab", { play_id: playId });
      navigate(`/squab/${data.challenge_id}`);
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return <button type="button" disabled={busy} onClick={invite} data-testid="squab-invite" className={className}>{busy ? "CREATING INVITE…" : "SQUAB WIT DA HOMIE"}</button>;
}
